export default {
  SET_CLUB_CLASSES(state, classes) {
    state.clubClasses_ = classes
  },
  ADD_CLUB_CLASSES(state, classes) {
    // state.clubClasses.push(Object.assign({}, classes))
    state.clubClasses = state.clubClasses_.concat(classes)
  },
  SET_CLUB_MODULES(state, classes) {
    state.clubModules = classes
  },
  SET_CLUB_LOCATIONS(state, locations) {
    state.clubLocations = locations
  },
  ADD_CLUB_LOCATION(state, location) {
    state.clubLocations.push(Object.assign({}, location))
  },
  SET_LOCATION_TIMES(state, classTimesByLocationTimes) {
    state.classTimesByLocationTimes = classTimesByLocationTimes
  },
}
